import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import React, { useCallback } from "react";

import { formatBytes } from "common";
import { colors } from "theme";

interface FileItemProps {
  index: number;
  file: File;
  onRemove: (index: number) => void;
  showSize?: boolean;
}

export const FileItem = ({ index, file, onRemove, showSize = true }: FileItemProps) => {
  const handleRemoveCallback = useCallback(() => {
    onRemove(index);
  }, [index, onRemove]);

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{ my: 3, border: (theme) => `1px solid ${theme.palette.action.focus}`, borderRadius: 1 }}
    >
      <Grid item container xs={6} sx={{ m: 1.5 }} alignItems="center">
        <Avatar sx={{ bgcolor: colors.blueLight }}>
          <UploadFileIcon color="primary" />
        </Avatar>
        <Box sx={{ ml: 1.5 }}>
          <Typography variant="subtitle1">{file.name}</Typography>
          <Typography variant="caption">{showSize ? formatBytes(file.size) : ""}</Typography>
        </Box>
      </Grid>
      <Grid item>
        <IconButton sx={{ m: 1.5 }} onClick={handleRemoveCallback}>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};
